import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useDispatch, useSelector } from 'react-redux';
import { Flow } from 'signup-constants/Flow';
import { AppKey } from '../app/AppKey';
import { checkLoginStatusIsSuspiciousUser } from '../auth/authUtils';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import imageUrls from '../images/imageUrls';
import { getQueryParam } from '../routing/getQueryParam';
import { getWindowLocationHref } from '../routing/getWindowLocationHref';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';
import { setWhichOAuthSelected, updateKeyValue } from '../store/app/action-creators';
import { getIsVerifiedByGoogleCredential, getWhichOAuthSelected } from '../store/app/selectors';
import { getAuthEmail } from '../store/auth/selectors';
import { clearError } from '../store/error/action-creators';
import { launchLoginPopup } from '../store/integrations/action-creators';
import { isFlow } from '../utils/isFlow';
import { isOauthFlow } from '../utils/oauthUtils';
import StandardError from './StandardError';
import { removeURLParameter } from './RemoveEmbedderParams';
import { isIntegratedApp } from '../utils/isIntegratedApp';
import { reloadFlow } from '../store/flow/action-creators';
import { getActiveError } from '../store/error/selectors';
import { ErrorKey } from './ErrorKey';
import { jsx as _jsx } from "react/jsx-runtime";
const ExistingAccountLoginView = () => {
  const email = useSelector(getAuthEmail);
  const oauth = useSelector(getWhichOAuthSelected);
  const isSuspiciousUserLoginStatus = useSelector(checkLoginStatusIsSuspiciousUser);
  const {
    redirectToLogin
  } = useLoginRedirect();
  const errorKey = useSelector(getActiveError);
  const dispatch = useDispatch();
  const isVerifiedByGoogleCredential = useSelector(getIsVerifiedByGoogleCredential);
  const handleButtonClick = () => {
    const isIntegrationFlow = isFlow(Flow.Integrations);
    const isIntegratedAppIntegration = isIntegratedApp();
    const isUserOnlyFlow = getFlowConfig().isUserOnlyFlow;
    const loginRedirectUrl = getQueryParam('loginRedirectUrl');
    if (isIntegrationFlow && isIntegratedAppIntegration) {
      dispatch(launchLoginPopup());
      return;
    }
    if (isOauthFlow() && loginRedirectUrl) {
      redirectToLogin({
        redirectUrl: loginRedirectUrl
      });
      return;
    }
    let url = getWindowLocationHref();
    if (isUserOnlyFlow && loginRedirectUrl) {
      url = loginRedirectUrl;
    }
    const updatedURL = removeURLParameter(url);
    redirectToLogin({
      redirectUrl: updatedURL
    });
  };
  const renderContent = () => {
    if (isSuspiciousUserLoginStatus && email && oauth) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `error.${errorKey}.description`,
        options: {
          email,
          oauth
        }
      });
    }
    return;
  };
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    handleButtonClick: handleButtonClick,
    handleLinkClick: () => {
      if (isVerifiedByGoogleCredential) {
        dispatch(updateKeyValue(AppKey.IsVerifiedByGoogleCredential, false));
        dispatch(setWhichOAuthSelected(null));
      }
      if (errorKey === ErrorKey.ExistingAccountVerificationError) {
        dispatch(reloadFlow());
      }
      dispatch(clearError());
    },
    imageURL: imageUrls.door,
    renderContent: renderContent,
    showSubtitle: !isSuspiciousUserLoginStatus
  });
};
export default ExistingAccountLoginView;